import Home from './home'
import Loading from './loading'
import Filter from './filter'
import Finish from './finish'
import Slide from './slide'
import Blacklight from './blacklight'
import SelectClock from './select-clock'
import Mirror from './mirror'
import Typeout from './typeout'
import DoNotPush from './do-not-push'
// import Back from './back'
// import ThreeD from './three-d'


export default [
  Home,
  Loading,
  Slide,
  Blacklight,
  SelectClock,
  DoNotPush,
  Typeout,
  Filter,
  Mirror,
  Finish
]


// WEBPACK FOOTER //
// ./src/stage/index.ts